import { Container } from '@mui/material'
import SubnetCalculatorInput from './subnetCalculatorInput'

const SubnetCalculator = () => {
  return (
    <Container maxWidth="md" className="subnet-calculator-tool" sx={{ padding: 0 }}>
      <SubnetCalculatorInput />
    </Container>
  )
}

export default SubnetCalculator